/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 18.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .service('ExternalAccountsHttp', [
    '$http',
    'externalAccountsConfig',
    function ExternalAccountsHttp($http, externalAccountsConfig) {
      'use strict';

      var basePath = externalAccountsConfig.restPath;

      this.all = function() {
        return $http.get(basePath);
      };

      this.get = function(key) {
        return $http.get(basePath + '/' + key);
      };

      this.checkCredentials = function(key, credentials) {
        return $http
          .post(basePath + '/' + key + '/check', credentials)
          .then(function(result) {
            return result;
          });
      };

      this.setCredentials = function(key, credentials) {
        if (credentials === null) {
          credentials = 'null';
        }

        return $http.post(basePath + '/' + key + '/credentials', credentials);
      };

      this.hasCredentials = function(key) {
        return $http.get(basePath + '/' + key + '/has').then(function(result) {
          return result;
        });
      };
    }
  ]);
